import { h } from 'preact'

interface ValueDescriptionsMap {
  [key: number]: string | JSX.Element
}

interface Props {
  options: any[]
  onChange?: (option: string, idx: number) => void
  onClick?: (option: string, idx: number) => void
  value: string | JSX.Element
  title?: string
  desc?: string
  valueDescriptions?: ValueDescriptionsMap
  meta?: string
  name?: string
  required?: boolean
  disabled?: boolean
  underneath?: boolean
  hideOptionLabel?: boolean
  key?: string
}
const RadioInputGroup = (props: Props) => {
  const input = props.options
    .map((option, idx) => <label className={`radio-inline${props.underneath ? ' radio-inline--underneath' : ''}`} key={props.key}>
      <input
        type='radio'
        name={props.name}
        className={`qa-${option}`}
        required={props.required}
        disabled={props.disabled}
        key={props.key}
        onChange={() => {
          if (props.onChange) {
            props.onChange(option, idx)
          }
        }}
        onClick={() => {
          if (props.onClick) {
            props.onClick(option, idx)
          }
        }}
        checked={option === props.value}
      />
      {props.hideOptionLabel === true ? null : option}
      {props.valueDescriptions && <p className='radio-value-description'>{props.valueDescriptions[idx]}</p>}
    </label>)
    .reduce((prev: any[], curr) => prev.concat([' ', curr]), [])

  return (
    <div className={`form-group ${props.title ? 'qa-' + props.title.split(' ').join('') : ''}`}>
      {
      props.title ? <label>{props.title}</label> : null
    }
      {props.desc ? <p className='radio-title-description'>{props.desc}</p> : null}
      {
      props.meta ? props.meta : null
    }
      <div className='radio-group'>
        {input}
      </div>
    </div>
  )
}

export default RadioInputGroup
